import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import MisSidebar from "./MisSidebar";
import { DownloadReportsComponent } from "./downloadReports";
// import IconNext from "../../assets/next.svg";
// import { toast } from "react-toastify";
import { LoaderPage } from "../../component/Loader";
import {
  fetchProjectReport,
  fetchStateProjectReport2,
  fetchProjectDetail,
  projectMinistry,
  projectScheme,
  projectMultiLocation,
  projectSingleLocation,
  issueState,
  issueStatus,
  projectStatus,
  schemeProject,
  fetchAllSchemes,
  fetchAllProjectStatus,
  fetchImplementationModes,
  downloadProjectSummary, //used for upload file
  uploadProjectSummary, //used for download file
  fetchFlatFileReport,
  fetchAllIssueCategories,
  fetchAllSectors,
  getAllStatesAction,
  // downloadedDataIssueCommentAndDecisionAction,
  getRecipientMinistryStateAction,
  getMisListAction
} from "../../actions/mis.action";
import { getGroupCategoryIdAction } from "../../actions/createProject.action";
import {
  getCategoryAction,
  getGroupsAction
} from "../../actions/userManagement.action";
import {
  fetchWorkflowStateData,
  fetchWorkflowStateDataForCentral
} from "../../actions/workflow.actions";
import { filter, get } from "lodash";

// Reports
import FlatFile from "./Reports/flatFile";
import ProjectSummary from "./Reports/projectSummary";
import StateSummary from "./Reports/stateSummary";
import MeetingSummary from "./meetingSummary";
import SchemeReport from "./Reports/schemeReport";
import MinistryReport from "./Reports/ministryReport";
import ProjectLocationReport from "./Reports/projectLocationReport";
import ProjectStatusReport from "./Reports/projectStatusReport";

import IssueStateReport from "./Reports/issueStateReport";
import IssueStatusReport from "./Reports/issueStatusReport";
import IssueLocationReport from "./Reports/issueLocationReport";
import MinistryIssuesReport from "./Reports/ministryIssuesReport";
// import CalendarFilter from "../calendarFilter/CalendarFilter";
import { STATUS } from "../../constant";
import { DATE_COVERSION, isValidArray, scrollToPosition } from "../../helper";
import Pagination from "../Pagination";
import { NodalOfficer } from "./nodalofficerListingTemplate";
import { MisHeader } from "./mis.header";
import {
  getDownloadMisReportByTypeAction,
  clearMisDownloadByTypeAction
} from "../../actions/dowloadExcelActions";
import { DocumentsComponent } from "./Documents/Documents";
import { DownloadManualComponent } from "./downloadUserManual";
import { DownloadCharts } from "./charts/downloadCharts";
import { getDistrictDepartmentByParentIds } from "../../actions/mis.action";
import { getIssueBySearch } from "../../actions/mis.action";
import { getLocalstorage, setLocalstorage } from "../../helper";
import { off } from "screenfull";
import mis from "../../reducer/mis.reducer";
import MinistryCompliance from "./Reports/ministryComplianceReport";
import { getMinistryForCompliance } from "../../services/apiServices";
import request from "../../services/requestService";
import StateCompliance from "./stateCompliance";
import DashboardSummary from "./Documents/DashboardSummary";
import MonthlyNewsLetter, {
  MonthlyNewsLetterComponent
} from "./Documents/MonthlyNewsLetter";
class Mis extends Component {
  state = {
    toggle: [],
    searchKeyword: "",
    ministryList: [],
    districtList: [],
    statesList: [],
    sponsoringMinistry: [],
    category: [],
    projectScheme: [],
    projectStatus: [],
    multiStateProject: "",
    monitoring: "",
    location: [],
    implementationMode: [],
    costFrom: 0,
    costTo: 0,
    createdDate: {},
    issueStatus: [],
    issueCategory: [],
    issueSubCategory: [],
    sector: [],
    recipientGroup: [],
    projectClassification: [],
    limit: 10,
    offset: 0,
    minRange: 0,
    maxRange: 10,
    pageLoadingStatus: true,
    filters: [],
    searchFilterForMinistry: {},
    issueState: {},
    chipResetCount: 0,
    ministryComplianceData: [],
    StateComplianceData: []
  };

  componentDidMount = async () => {
    const { fetchProjectReport } = this.props;
    const projectReportParams = this.fetchProjectReportParams();
    fetchProjectReport(projectReportParams);
    this.getInitialData();
  };

  async componentWillReceiveProps(nextProps, nextContext) {
    const { activeReport } = this.props;
    if (nextProps.activeReport !== activeReport) {
      this.setState({
        toggle: [],
        searchKeyword: "",
        sponsoringMinistry: [],
        category: [],
        projectScheme: [],
        projectStatus: [],
        multiStateProject: "",
        monitoring: "",
        location: [],
        implementationMode: [],
        costFrom: 0,
        costTo: 0,
        createdDate: {},
        issueStatus: [],
        issueCategory: [],
        sector: [],
        recipientGroup: [],
        projectClassification: [],
        issueSubCategory: [],
        limit: 10,
        offset: 0,
        minRange: 0,
        maxRange: 10,
        issueState: []
      });
    }
  }

  fetchProjectReportParams = () => {
    const {
      searchKeyword,
      category,
      sponsoringMinistry,
      multiStateProject,
      projectScheme,
      monitoring,
      location,
      projectStatus,
      projectStatusDate,
      costFrom,
      costTo,
      implementationMode,
      limit,
      offset,
      createdDate,
      projectResolvedDate,
      districtDepartments = [],
      issueState
    } = this.state;
    let data = {
      limit: limit,
      offset: offset
    };

    if (category.length) {
      data.category = category;
    }

    if (createdDate && (createdDate.from && createdDate.to)) {
      data.createdDate = DATE_COVERSION(createdDate);
    }

    if (projectStatusDate && (projectStatusDate.from && projectStatusDate.to)) {
      data.createdDate = DATE_COVERSION(projectStatusDate);
    }

    if (implementationMode.length) {
      data.implementationMode = implementationMode;
    }
    if (location.length) {
      data.location = location;
    }
    if (monitoring) {
      data.monitoring = monitoring;
    }
    if (multiStateProject) {
      data.multiStateProject = multiStateProject;
    }

    if (costFrom || costTo) {
      data.projectCost = [
        {
          from: costFrom,
          to: costTo
        }
      ];
    }
    if (projectScheme.length) {
      data.projectScheme = projectScheme;
    }
    if (issueState.length) {
      data.issueState = issueState;
    }
    if (projectStatus.length) {
      data.projectStatus = projectStatus;
    }
    if (sponsoringMinistry.length) {
      data.sponsoringMinistry = sponsoringMinistry;
    }
    if (districtDepartments.length) {
      data.districtDepartments = districtDepartments;
    }
    if (searchKeyword) {
      data.searchKeyword = searchKeyword;
    }
    if (
      projectResolvedDate &&
      (projectResolvedDate.from && projectResolvedDate.to)
    ) {
      data.projectResolvedDate = DATE_COVERSION(projectResolvedDate);
    }
    return data;
  };

  fetchFlatFileParams = () => {
    const {
      searchKeyword,
      category,
      sponsoringMinistry,
      multiStateProject,
      projectScheme,
      location,
      costFrom,
      costTo,
      implementationMode,
      limit,
      offset,
      createdDate,
      issueStatus,
      issueCategory,
      issueSubCategory,
      sector,
      recipientGroup,
      projectClassification,
      projectStatus,
      issueCreatedDate,
      districtDepartments = [],
      issueState
    } = this.state;
    let data = {
      limit: limit,
      offset: offset
    };
    if (category.length) {
      data.category = category;
    }

    if (createdDate && (createdDate.from || createdDate.to)) {
      data.createdDate = DATE_COVERSION(createdDate);
    }

    if (issueCreatedDate && (issueCreatedDate.from || issueCreatedDate.to)) {
      data.issueCreatedDate = DATE_COVERSION(issueCreatedDate);
    }

    if (implementationMode.length) {
      data.implementationMode = implementationMode;
    }
    if (location.length) {
      data.location = location;
    }
    if (multiStateProject) {
      data.multiStateProject = multiStateProject;
    }
    if (costFrom || costTo) {
      data.projectCost = [
        {
          from: costFrom,
          to: costTo
        }
      ];
    }
    if (projectScheme.length) {
      data.projectScheme = projectScheme;
    }
    if (issueState.length) {
      data.issueState = issueState;
    }
    if (sponsoringMinistry.length) {
      data.sponsoringMinistry = sponsoringMinistry;
    }
    if (searchKeyword) {
      data.searchKeyword = searchKeyword;
    }
    if (issueStatus.length) {
      data.issueStatus = issueStatus;
    }
    if (issueCategory.length) {
      data.issueCategory = issueCategory;
    }
    if (issueSubCategory.length) {
      data.issueSubCategory = issueSubCategory;
    }
    if (sector.length) {
      data.sector = sector;
    }
    if (recipientGroup.length) {
      data.recipientGroup = recipientGroup;
    }
    if (districtDepartments.length) {
      data.districtDepartments = districtDepartments;
    }
    if (projectClassification.length) {
      data.projectClassification = projectClassification;
    }
    if (projectStatus.length) {
      data.projectStatus = projectStatus;
    }

    return data;
  };

  fetchFlatFile = () => {
    const { offset, limit, misPagination } = this.state;
    const appliedFilter = getLocalstorage("filters");
    const filteredFilters =
      appliedFilter &&
      appliedFilter.map(({ value, optionName }) => ({
        value,
        optionName
      }));
    let results = {
      limit: limit,
      offset: offset,
      searchKeyword: misPagination && misPagination.searchKeyword,
      type: misPagination && misPagination.type
    };
    filteredFilters &&
      filteredFilters.forEach((item, index) => {
        let valueToPush = item.value;
        if (
          item.optionName === "projectClassification" ||
          item.optionName === "implementationMode" ||
          item.optionName === "projectStatus" ||
          item.optionName === "createdDate" ||
          item.optionName === "issueCreatedDate" ||
          item.optionName === "issueStatus" ||
          item.optionName === "projectCost"
        ) {
          valueToPush = item.value;
        } else {
          valueToPush = parseInt(item.value);
        }
        if (results[item.optionName]) {
          if (Array.isArray(results[item.optionName])) {
            results[item.optionName].push(valueToPush);
          } else {
            results[item.optionName] = [results[item.optionName], valueToPush];
          }
        } else {
          results[item.optionName] =
            item.optionName === "createdDate" ||
            item.optionName === "issueCreatedDate"
              ? valueToPush
              : [valueToPush];
        }
      });
    return results;
  };

  fetchFlatFileIncaseNoFilterApplied = () => {
    const { misData } = this.props;
    const data = get(misData, "data");
    let totalItem = 0;

    if (isValidArray(data)) {
      const itemCount = data.length;
      if (data[0].total) {
        totalItem = data[0].total;
      } else if (data.total > 0) {
        totalItem = data.total;
      } else if (itemCount > 0) {
        totalItem = itemCount;
      }
    }
    const { limit, offset, misPagination } = this.state;
    let results = {
      limit: totalItem,
      category: null,
      createdDate: null,
      districtDepartments: null,
      implementationMode: null,
      issueCategory: null,
      issueCreatedDate: null,
      issueStatus: null,
      issueSubCategory: null,
      location: null,
      monitoring: null,
      multiStateProject: null,
      projectClassification: null,
      projectResolvedDate: null,
      projectScheme: null,
      projectStatus: null,
      recipientGroup: null,
      searchKeyword: (misPagination && misPagination.searchKeyword) || null,
      sector: null,
      sponsoringMinistry: null,
      offset: 0
    };
    return results;
  };

  fetchProjectReportWithFilters = () => {
    const { offset, limit } = this.state;
    const { misPagination } = this.state;
    const appliedFilter = getLocalstorage("projectSummaryFilters");
    const filteredFilters =
      appliedFilter &&
      appliedFilter.map(({ value, optionName }) => ({
        value,
        optionName
      }));
    let results = {
      limit: limit,
      offset: offset,
      searchKeyword: misPagination && misPagination.searchKeyword,
      type: misPagination && misPagination.type
    };
    filteredFilters &&
      filteredFilters.forEach((item, index) => {
        let valueToPush = item.value;
        if (
          item.optionName === "multiStateProject" ||
          item.optionName === "implementationMode" ||
          item.optionName === "monitoring" ||
          item.optionName === "projectStatus" ||
          item.optionName === "createdDate" ||
          item.optionName === "projectCost"
        ) {
          valueToPush = item.value;
        } else {
          valueToPush = parseInt(item.value);
        }
        if (results[item.optionName]) {
          if (Array.isArray(results[item.optionName])) {
            results[item.optionName].push(valueToPush);
          } else {
            results[item.optionName] = [results[item.optionName], valueToPush];
          }
        } else {
          results[item.optionName] =
            item.optionName === "createdDate" ||
            item.optionName === "multiStateProject" ||
            item.optionName === "monitoring"
              ? valueToPush
              : [valueToPush];
        }
      });
    if (
      results["multiStateProject"] &&
      isValidArray(results["multiStateProject"])
    ) {
      results["multiStateProject"] = "All";
    }
    if (results["monitoring"] && isValidArray(results["monitoring"])) {
      results["monitoring"] = "All";
    }
    return results;
  };

  handleProjectCostChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  updateFlatFileFilters = (filters, multiStateProject) => {
    const {
      fetchFlatFileReport,
      getDistrictDepartmentByParentIds
    } = this.props;
    if (
      multiStateProject &&
      multiStateProject !== this.state.multiStateProject
    ) {
      this.setState({ multiStateProject: multiStateProject, offset: 0 }, () => {
        const flatFileParams = this.fetchFlatFileParams();
        fetchFlatFileReport(flatFileParams);
      });
    } else {
      let sponsoringMinistry = [],
        category = [],
        schemes = [],
        location = [],
        implementationMode = [],
        issueStatus = [],
        issueCategory = [],
        sector = [],
        recipientGroup = [],
        districtDepartments = [],
        projectClassification = [],
        issueSubCategory = [],
        projectStatus = [],
        projectCreatedDate,
        issueCreatedDate;
      for (let i = 0; i < filters.length; i++) {
        switch (filters[i].type) {
          case "ministry":
            sponsoringMinistry.push(parseFloat(filters[i].id));
            break;
          case "states":
            sponsoringMinistry.push(parseFloat(filters[i].id));
            break;
          case "scheme":
            schemes.push(parseFloat(filters[i].id));
            break;
          case "category":
            category.push(filters[i].id);

            break;
          case "location":
            location.push(parseFloat(filters[i].id));
            break;
          case "implementationMode":
            implementationMode.push(filters[i].id);
            break;
          case "issueStatus":
            issueStatus.push(filters[i].id);
            break;
          case "issueCategory":
            issueCategory.push(parseFloat(filters[i].id));
            break;
          case "sector":
            sector.push(parseFloat(filters[i].id));
            break;
          case "recipientGroup":
            recipientGroup.push(parseFloat(filters[i].id));
            getDistrictDepartmentByParentIds(recipientGroup).then(resp => {
              if (resp && resp.data) {
                this.setState({
                  districtList: resp.data
                });
              }
            });
            break;
          case "districtDepartments":
            districtDepartments.push(parseFloat(filters[i].id));
            break;
          case "projectClassification":
            projectClassification.push(filters[i].id);
            break;
          case "issueSubCategory":
            issueSubCategory.push(parseFloat(filters[i].id));
            break;
          case "projectStatus":
            projectStatus.push(filters[i].id);
            break;
          case "createdDate":
          case "Project Status Created Date":
            projectCreatedDate = filters[i].createdDate;
            break;
          case "issueCreatedDate":
          case "Issue Status Date":
            issueCreatedDate = filters[i].issueCreatedDate;
            break;
          default:
            break;
        }
      }

      this.setState(
        {
          sponsoringMinistry: sponsoringMinistry,
          category: category,
          projectScheme: schemes,
          issueState: issueState,
          location: location,
          implementationMode: implementationMode,
          issueStatus: issueStatus,
          issueCategory: issueCategory,
          sector: sector,
          recipientGroup: recipientGroup,
          districtDepartments: districtDepartments,
          projectClassification: projectClassification,
          issueSubCategory: issueSubCategory,
          projectStatus: projectStatus,
          createdDate: projectCreatedDate,
          issueCreatedDate,
          offset: 0,
          limit: 10
        },
        () => {
          const flatFileParams = this.fetchFlatFileParams();
          fetchFlatFileReport(flatFileParams);
        }
      );
    }
  };

  updateSelectBoxesData = (filters, multiStateProject, monitoring) => {
    const { fetchProjectReport } = this.props;
    let sponsoringMinistry = [],
      category = [],
      schemes = [],
      location = [],
      implementationMode = [],
      projectStatus = [],
      createdDate,
      districtDepartments = [],
      projectResolvedDate;
    if (monitoring !== this.state.monitoring) {
      const projectStatusFilter = filters.filter(
        value => value.type === "projectStatus"
      );
      isValidArray(projectStatusFilter) &&
        projectStatus.push(projectStatusFilter[0].id);
      this.setState(
        {
          monitoring: monitoring,
          offset: 0,
          projectStatus,
          projectResolvedDate:
            monitoring === "Passive" ? this.state.projectResolvedDate : null,
          createdDate: null
        },
        () => {
          const projectReportParams = this.fetchProjectReportParams();
          fetchProjectReport(projectReportParams);
        }
      );
    } else if (multiStateProject !== this.state.multiStateProject) {
      this.setState({ multiStateProject: multiStateProject, offset: 0 }, () => {
        const projectReportParams = this.fetchProjectReportParams();
        fetchProjectReport(projectReportParams);
      });
    } else {
      for (let i = 0; i < filters.length; i++) {
        switch (filters[i].type) {
          case "ministry":
            sponsoringMinistry.push(parseFloat(filters[i].id));
            break;
          case "districtDepartments":
            districtDepartments.push(parseFloat(filters[i].id));
            break;
          case "states":
            sponsoringMinistry.push(parseFloat(filters[i].id));
            break;
          case "scheme":
            schemes.push(parseFloat(filters[i].id));
            break;
          case "category":
            category.push(filters[i].id);
            break;
          case "location":
            location.push(parseFloat(filters[i].id));
            break;
          case "implementationMode":
            implementationMode.push(filters[i].id);
            break;
          case "projectStatus":
            projectStatus.push(filters[i].id);
            break;
          case "createdDate":
            createdDate = filters[i].createdDate;
            break;
          case "projectResolvedDate":
            projectResolvedDate = filters[i].projectResolvedDate;
            break;
          default:
            break;
        }
      }
      this.setState(
        {
          sponsoringMinistry: sponsoringMinistry,
          districtDepartments: districtDepartments,
          category: category,
          projectScheme: schemes,
          location: location,
          implementationMode: implementationMode,
          projectStatus: projectStatus,
          projectResolvedDate,
          createdDate,
          offset: 0,
          limit: 10
        },
        () => {
          const projectReportParams = this.fetchProjectReportParams();
          fetchProjectReport(projectReportParams);
        }
      );
    }
  };

  getInitialData = async () => {
    const {
      getGroupCategoryIdAction,
      getDistrictDepartmentByParentIds
    } = this.props;
    const ministryList = await getGroupCategoryIdAction(undefined, {
      category: ["CENTRAL", "PMG"]
    });
    const statesList = await getGroupCategoryIdAction(undefined, {
      category: ["STATE"]
    });
    const districtListResponse = await getDistrictDepartmentByParentIds([]);
    await this.props.getCategoryAction();
    await this.props.fetchAllSectors();
    await this.props.fetchWorkflowStateData();
    await this.props.fetchAllIssueCategories();
    await this.props.getGroupsAction();
    await this.props.fetchAllSchemes();
    await this.props.fetchAllProjectStatus();
    await this.props.fetchWorkflowStateDataForCentral();
    await this.props.fetchImplementationModes();
    await this.props.getRecipientMinistryStateAction();
    //await this.props.fetchFlatFileReport({ limit: 10, offset: 0 });
    await this.props.getAllStatesDispatch();
    this.setState({
      ministryList: ministryList && ministryList.data,
      statesList: statesList && statesList.data,
      districtList: districtListResponse && districtListResponse.data,
      pageLoadingStatus: false
    });
  };

  displayToast = (message, type) => {
    const { toastManager } = this.props;
    toastManager.add(message, {
      appearance: type,
      autoDismiss: true
    });
  };

  onDateChange = value => {
    this.setState({ createdDate: value.createdDate });
  };

  onChange = event => {
    this.setState({ searchKeyword: event.target.value });
  };

  handleToggle = async (name, id) => {
    const { toggle } = this.state;
    await this.props.fetchProjectDetail(id);
    toggle[name] = !toggle[name];
    this.setState({
      toggle: toggle
    });
  };

  filterData = () => {
    const { activeReport, selectedState } = this.props;
    const {
      createdDate,
      searchKeyword,
      limit,
      offset,
      searchFilterForMinistry
    } = this.state;
    const data = {
      createdDate: createdDate,
      searchKeyword:
        activeReport === "MINISTRY_REPORT"
          ? searchFilterForMinistry && searchFilterForMinistry.searchKeyword
          : searchKeyword,
      limit: limit,
      offset: offset
    };
    let selectedMonitoring;
    if (
      JSON.parse(localStorage.getItem("monitoring")) == null ||
      JSON.parse(localStorage.getItem("monitoring")) == undefined
    ) {
      selectedMonitoring = {
        name: "",
        label: "Select Monitoring Flag",
        value: " ",
        optionName: "Select Monitoring FlaG"
      };
    } else {
      selectedMonitoring = JSON.parse(localStorage.getItem("monitoring"));
    }
    let selectedMeetingType;
    if (
      JSON.parse(localStorage.getItem("meetingType")) == null ||
      JSON.parse(localStorage.getItem("meetingType")) == undefined
    ) {
      selectedMeetingType = {
        name: "",
        label: "Select Meeting Type",
        value: " ",
        optionName: "Select Meeting Type"
      };
    } else {
      selectedMeetingType = JSON.parse(localStorage.getItem("meetingType"));
    }

    switch (activeReport) {
      case "FLAT_FILE":
        this.props.fetchFlatFileReport(this.fetchFlatFile());
        break;
      case "MEETINGS_SUMMARY":
        this.props.getMisListAction(
          selectedState,
          selectedMeetingType,
          this.state.offset
        );
        break;
      case "STATE_SUMMARY":
        this.props.fetchStateProjectReport2(
          selectedState,
          selectedMonitoring,
          this.state.offset
        );
        break;
      case "PROJECT_SUMMARY":
        this.props.fetchProjectReport(this.fetchProjectReportWithFilters());
        break;
      case "MINISTRY_REPORT":
        this.props.projectScheme(data);
        break;
      case "MINISTRY_COMPLIANCE":
        this.props.projectScheme(data);
        break;
      case "SCHEME_REPORT":
        this.props.schemeProject(data);
        break;
      case "ISSUE_LOCATION":
        this.props.projectMultiLocation(data);
        break;
      case "LOCATION_REPORT":
        this.props.projectSingleLocation(data);
        break;
      case "ISSUE_STATE":
        this.props.issueState(data);
        break;
      case "ISSUE_STATUS":
        this.props.issueStatus(data);
        break;
      case "PROJECT_STATUS":
        this.props.projectStatus(data);
        break;
      case "MINISTRY_ISSUES":
        this.props.projectMinistry(data);
        break;
      default:
        break;
    }
  };

  handleClearFilters = () => {
    this.setState(
      {
        toggle: [],
        searchKeyword: "",
        sponsoringMinistry: [],
        category: [],
        projectScheme: [],
        projectStatus: [],
        multiStateProject: "",
        monitoring: "",
        location: [],
        implementationMode: [],
        costFrom: 0,
        costTo: 0,
        createdDate: {},
        issueStatus: [],
        issueCategory: [],
        issueSubCategory: [],
        sector: [],
        recipientGroup: [],
        districtDepartments: [],
        projectClassification: [],
        limit: 10,
        offset: 0
      },
      () => {
        this.filterData();
      }
    );
  };

  onPageChange = pageNumber => {
    const { activeReport } = this.props;
    const misPageChanged = getLocalstorage("misPageChanged");

    let states;
    let originalKeyWord = "";
    let originalType = "";
    if (this.state.misPagination) {
      originalKeyWord = this.state.misPagination.searchKeyword;
      originalType = this.state.misPagination.type;
    }

    if (misPageChanged || originalKeyWord.length === 0) {
      states = {
        offset: pageNumber.selected,
        ...pageNumber,
        misPagination: {
          searchKeyword: "",
          type: ""
        }
      };
    } else {
      states = {
        offset: pageNumber.selected,
        ...pageNumber,
        misPagination: {
          searchKeyword: originalKeyWord,
          type: originalType
        }
      };
    }

    this.setState(states, () => {
      this.filterData();
    });
    setLocalstorage("misPageChanged", false);
    //scrollToPosition({ top: 0 });
    if (activeReport === "MEETINGS_SUMMARY") {
      //const middlePosition = document.body.scrollHeight / 4;
      const targetDiv = document.querySelector(".issue-main-container1");

      const scrollPosition = targetDiv.offsetTop;
      const pixelsToScrollAbove = 25;
      window.scrollTo({
        top: scrollPosition - pixelsToScrollAbove,
        behavior: "smooth"
      });
    }
  };

  fetchMinistryReports = () => {
    const { misData } = this.props;
    const activeReportTitle = this.activeReportTitle();
    const { searchFilterForMinistry, issueState } = this.state;
    const data = get(misData, "data");
    let totalItem = 0;

    if (isValidArray(data)) {
      const itemCount = data.length;
      if (data[0].total) {
        totalItem = data[0].total;
      } else if (data.total > 0) {
        totalItem = data.total;
      } else if (itemCount > 0) {
        totalItem = itemCount;
      }
    }
    let results = {
      limit: totalItem,
      offset: 0,
      searchKeyword:
        activeReportTitle === "Ministry Report"
          ? searchFilterForMinistry && searchFilterForMinistry.searchKeyword
          : issueState && issueState.searchKeyword
    };
    return results;
  };

  downloadExcel = () => {
    const { activeReport } = this.props;
    const appliedFilter = getLocalstorage("filters");
    const appliedProjectFilter = getLocalstorage("projectSummaryFilters");
    const data =
      activeReport === "FLAT_FILE"
        ? appliedFilter === null
          ? this.fetchFlatFileIncaseNoFilterApplied()
          : this.fetchFlatFile()
        : activeReport === "PROJECT_SUMMARY"
        ? appliedProjectFilter === null
          ? this.fetchFlatFileIncaseNoFilterApplied()
          : this.fetchProjectReportWithFilters()
        : this.fetchMinistryReports();
    this.getDownloadReports(data, activeReport);
  };

  getDownloadReports = (data, report) => {
    const { getDownloadMisReportByTypeAction } = this.props;
    getDownloadMisReportByTypeAction(undefined, data, report);
  };

  onClearDownload = () => {
    const { clearMisDownloadByTypeAction } = this.props;
    clearMisDownloadByTypeAction();
  };

  activeReportTitle = () => {
    const { activeReport } = this.props;
    const title = mapActiveReportTitle(activeReport);
    return title;
  };

  callAfterDebounce = () => {
    const {
      fetchFlatFileReport,
      fetchProjectReport,
      projectScheme,
      fetchStateProjectReport2,
      issueState
    } = this.props;
    const data = {
      limit: 10,
      offset: 0
    };
    const payloadForMinistryReport = {
      ...data,
      ...this.state.searchFilterForMinistry
    };
    const activeReportTitle = this.activeReportTitle();

    const payload = null;
    if (activeReportTitle === "Issues Summary") {
      fetchFlatFileReport(this.state.misPagination);
    } else if (activeReportTitle === "State Summary") {
      fetchStateProjectReport2(this.state.misPagination, undefined);
    } else if (activeReportTitle === "Meetings Summary") {
      fetchProjectReport(this.state.misPagination, undefined);
    } else if (activeReportTitle === "Projects Summary") {
      fetchProjectReport(this.state.misPagination, undefined);
    } else if (activeReportTitle === "Ministry Report") {
      projectScheme(payloadForMinistryReport);
    } else if (activeReportTitle === "Ministry/State Agenda") {
      issueState(this.state.issueState);
    }
  };

  onSearch = value => {
    const activeReportTitle = this.activeReportTitle();
    let payload = null;
    if (activeReportTitle === "Issues Summary") {
      payload = { type: "Issue", searchKeyword: value };
      this.setState({ misPagination: payload, offset: 0 });
    } else if (activeReportTitle === "State Summary") {
      payload = { type: "Project", searchKeyword: value };
      this.setState({ misPagination: payload, offset: 0 });
    } else if (activeReportTitle === "Projects Summary") {
      payload = { type: "Project", searchKeyword: value };
      this.setState({ misPagination: payload, offset: 0 });
    } else if (activeReportTitle === "Ministry Report") {
      payload = { type: "Ministry Report", searchKeyword: value };
      this.setState({ searchFilterForMinistry: payload, offset: 0 });
    } else if (activeReportTitle === "Ministry/State Agenda") {
      payload = { type: "Ministry/State Agenda", searchKeyword: value };
      this.setState({ issueState: payload, offset: 0 });
    }
  };

  onClearFilter = value => {
    if (value) {
      this.setState({
        offset: 0
      });
    }
  };

  onClearProjectFilter = value => {
    if (value) {
      this.setState({
        offset: 0
      });
    }
  };

  onstateValueChange = value => {
    if (value) {
      this.setState({
        offset: 0
      });
    }
  };

  clearState = () => {
    this.setState({ chipResetCount: this.state.chipResetCount + 1 });
  };

  onOpenOfModal = (modalState, previousFilterCount, currentFilterCount) => {
    if (modalState) {
      if (
        previousFilterCount !== undefined ||
        currentFilterCount !== undefined ||
        previousFilterCount !== currentFilterCount
      ) {
        this.setState({
          offset: 0
        });
      }
    }
  };

  onOpenOfProjectSummaryModal = (
    projectModalState,
    previousFilterCount,
    currentFilterCount
  ) => {
    if (projectModalState) {
      if (
        previousFilterCount !== undefined ||
        currentFilterCount !== undefined ||
        previousFilterCount !== currentFilterCount
      ) {
        this.setState({
          offset: 0
        });
      }
    }
  };

  render() {
    const {
      props: {
        misData,
        misDownload,
        schemesList,
        sectorsList,
        activeReport,
        categoryList,
        statesListData,
        issueStatusList,
        misFlatFileStatus,
        projectDetailData,
        projectStatusList,
        issueCategoriesList,
        recipientGroupsList,
        misSponoringMinistry,
        implementationModesList,
        documentsStatusLoader,
        workflowStateDataForCentral,
        stateProjectsList,
        selectedState,
        misIssueList
      },
      state: {
        costTo,
        offset,
        toggle,
        costFrom,
        minRange,
        statesList,
        ministryList,
        districtList,
        filters,
        misPagination,
        ministryComplianceData,
        stateComplianceData
      },
      downloadExcel,
      onClearDownload,
      callAfterDebounce,
      onSearch
    } = this;
    window.onload = function() {
      setLocalstorage("filters", null);
      setLocalstorage("projectSummaryFilters", null);
    };
    const data = get(misData, "data");
    let totalItem = 0;
    const isUserPMG = getLocalstorage("groupCategory") === "PMG";

    if (isValidArray(data)) {
      const itemCount = data.length;
      if (data[0].total) {
        totalItem = data[0].total;
      } else if (data.total > 0) {
        totalItem = data.total;
      } else if (itemCount > 0) {
        totalItem = itemCount;
      }
    }
    const title = mapActiveReportTitle(activeReport);
    if (selectedState !== null && selectedState !== undefined) {
    } else {
    }

    return (
      <React.Fragment>
        <LoaderPage
          loading={
            (misFlatFileStatus === STATUS.LOADING &&
              activeReport != "MINISTRY_COMPLIANCE") ||
            documentsStatusLoader
          }
        />
        <div className="mis-wrapper">
          <div className="mis-sidebar">
            <MisSidebar />
          </div>
          <div className="mis-projects">
            {activeReport !== "NODAL_OFFICER" &&
            activeReport !== "DOWNLOAD_REPORT" &&
            activeReport !== "DOCUMENT_ATTACHMENTS" &&
            activeReport !== "DASHBOARD_SUMMARY" &&
            activeReport !== "DOWNLOAD_MANUAL" &&
            activeReport !== "CHARTS" &&
            activeReport !== "STATE_SUMMARY" &&
            activeReport !== "MINISTRY_COMPLIANCE" &&
            activeReport !== "STATE_DATA_COMPLIANCE" &&
            activeReport !== "MONTHLY_NEWSLETTER" ? (
              <MisHeader
                isLoading={misDownload.isLoading}
                downloadLink={misDownload.downloadingSrc}
                onClearDownload={onClearDownload}
                onStartDownloading={downloadExcel}
                totalItem={totalItem}
                title={title}
                activeReport={activeReport}
                callAfterDebounce={callAfterDebounce}
                onSearch={onSearch}
                onOpenOfModal={this.onOpenOfModal}
                onOpenOfProjectSummaryModal={this.onOpenOfProjectSummaryModal}
                onstateValueChange={this.onstateValueChange}
                chipResetCount={this.state.chipResetCount}
              />
            ) : null}

            {activeReport === "STATE_SUMMARY" &&
              (stateProjectsList.data !== null &&
                stateProjectsList.data !== undefined) && (
                <MisHeader
                  isLoading={misDownload.isLoading}
                  downloadLink={misDownload.downloadingSrc}
                  onClearDownload={onClearDownload}
                  onStartDownloading={downloadExcel}
                  totalItem={stateProjectsList.data.total}
                  title={title}
                  activeReport={activeReport}
                  callAfterDebounce={callAfterDebounce}
                  //onSearch={onSearch}
                  onOpenOfModal={this.onOpenOfModal}
                  onOpenOfProjectSummaryModal={this.onOpenOfProjectSummaryModal}
                  chipResetCount={this.state.chipResetCount}
                />
              )}

            {(activeReport === "FLAT_FILE" && (
              <FlatFile
                misData={misData}
                projectDetailData={projectDetailData}
                handleToggle={this.handleToggle}
                toggle={toggle}
                ministryList={ministryList}
                districtList={districtList}
                statesList={statesList}
                categoryList={get(categoryList, "data")}
                schemesList={get(schemesList, "data")}
                statesListData={get(statesListData, "data")}
                implementationModesList={get(
                  implementationModesList,
                  "data.implementationModeList"
                )}
                projectStatusList={get(projectStatusList, "data.statuses")}
                issueCategoriesList={get(issueCategoriesList, "data")}
                recipientGroupsList={get(recipientGroupsList, "data")}
                sectorsList={get(sectorsList, "data")}
                issueStatusList={issueStatusList}
                sponoringMinistry={misSponoringMinistry}
                handleChange={this.handleProjectCostChange}
                costFrom={costFrom}
                costTo={costTo}
                filterData={this.filterData}
                handleClearFilters={this.handleClearFilters}
                updateFilters={this.updateFlatFileFilters}
                workflowStateDataForCentral={workflowStateDataForCentral}
                filters={filters}
                onClearFilter={this.onClearFilter}
              />
            )) ||
              null}

            {(activeReport === "NODAL_OFFICER" && <NodalOfficer />) || null}
            {activeReport === "MEETINGS_SUMMARY" && (
              <MeetingSummary
                selectedmeetingType={this.selectedmeetingType}
                offset={this.state.offset}
                onstateValueChange={this.onstateValueChange}
                clearStateYellowChips={this.clearState}
              />
            )}

            {activeReport === "STATE_SUMMARY" && (
              <StateSummary
                misDataReport={misData}
                clearStateYellowChips={this.clearState}
              />
            )}
            {activeReport === "STATE_DATA_COMPLIANCE" && (
              <StateCompliance misData={stateComplianceData} />
            )}

            {activeReport === "PROJECT_SUMMARY" && (
              <ProjectSummary
                misData={misData}
                handleToggle={this.handleToggle}
                projectDetailData={projectDetailData}
                toggle={toggle}
                categoryList={get(categoryList, "data")}
                schemesList={get(schemesList, "data")}
                ministryList={ministryList}
                districtList={districtList}
                statesList={statesList}
                statesListData={get(statesListData, "data")}
                implementationModesList={get(
                  implementationModesList,
                  "data.implementationModeList"
                )}
                projectStatusList={get(projectStatusList, "data.statuses")}
                handleChange={this.handleProjectCostChange}
                costFrom={costFrom}
                costTo={costTo}
                filterData={this.filterData}
                handleClearFilters={this.handleClearFilters}
                updateSelectBoxesData={this.updateSelectBoxesData}
                onClearProjectFilter={this.onClearProjectFilter}
              />
            )}

            {activeReport === "SCHEME_REPORT" &&
              isValidArray(get(misData, "data")) && (
                <SchemeReport misData={misData} />
              )}

            {activeReport === "MINISTRY_REPORT" && (
              <MinistryReport misData={misData} />
            )}
            {activeReport === "MINISTRY_COMPLIANCE" && (
              <MinistryCompliance misData={ministryComplianceData} />
            )}
            {activeReport === "LOCATION_REPORT" &&
              isValidArray(get(misData, "data")) && (
                <ProjectLocationReport misData={misData} />
              )}

            {activeReport === "PROJECT_STATUS" &&
              isValidArray(get(misData, "data")) && (
                <ProjectStatusReport misData={misData} />
              )}

            {activeReport === "ISSUE_STATUS" &&
              isValidArray(get(misData, "data")) && (
                <IssueStatusReport misData={misData} />
              )}

            {activeReport === "ISSUE_STATE" && (
              <IssueStateReport misData={misData} />
            )}

            {activeReport === "ISSUE_LOCATION" &&
              isValidArray(get(misData, "data")) && (
                <IssueLocationReport misData={misData} />
              )}

            {activeReport === "MINISTRY_ISSUES" &&
              isValidArray(get(misData, "data")) && (
                <MinistryIssuesReport misData={misData} />
              )}

            {activeReport === "DOWNLOAD_REPORT" ? (
              <DownloadReportsComponent />
            ) : null}

            {activeReport === "DOCUMENT_ATTACHMENTS" ? (
              <DocumentsComponent />
            ) : null}

            {activeReport === "DASHBOARD_SUMMARY" ? <DashboardSummary /> : null}

            {/* {activeReport === "MONTHLY_NEWSLETTER" ? (
              <MonthlyNewsLetterComponent />
            ) : null} */}

            {/* {activeReport === "DOWNLOAD_MANUAL" ? (
              <DownloadManualComponent />
            ) : null} */}
            {activeReport === "CHARTS" ? <DownloadCharts /> : null}

            {activeReport === "NODAL_OFFISER" ? <NodalOfficer /> : null}

            {(activeReport === "PROJECT_SUMMARY" ||
              activeReport === "FLAT_FILE" ||
              activeReport === "MINISTRY_REPORT") &&
            isValidArray(get(misData, "data")) &&
            get(misData, "data[0].total") > 10 ? (
              <div className="pagination-wrapper">
                <div className="pagination m-0">
                  <Pagination
                    limit={10}
                    pageCount={Math.ceil(get(misData, "data[0].total") / 10)}
                    onPageChange={this.onPageChange}
                    offset={offset}
                  />
                </div>
              </div>
            ) : null}
            {/* {(activeReport === "STATE_SUMMARY") &&
              isValidArray(get(stateProjectsList.data, "listDTO")) &&
              get(stateProjectsList, "data.total") > 10 ? (
                <div className="pagination-wrapper">
                  <div className="pagination m-0">
                    <Pagination
                      limit={10}
                      pageCount={Math.ceil(get(stateProjectsList, "data.total") / 10)}
                      onPageChange={this.onPageChange}
                      offset={offset}
                    />
                  </div>
                </div>
              ) :
              null} */}

            {activeReport === "MEETINGS_SUMMARY" &&
            isValidArray(get(misIssueList.data, "listDTO")) &&
            get(misIssueList, "data.total") > 10 ? (
              <div className="pagination-wrapper">
                <div className="pagination m-0">
                  <Pagination
                    limit={10}
                    pageCount={Math.ceil(get(misIssueList, "data.total") / 10)}
                    onPageChange={this.onPageChange}
                    offset={offset}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    misData: state.misReducer.data,
    loading: state.misReducer.misStatus,
    projectDetailData: state.misReducer.projectDetailData,
    activeReport: state.misReducer.activeReport,
    categoryList: state.userManagementReducer.categoryList,
    schemesList: state.misReducer.schemesList,
    implementationModesList: state.misReducer.implementationModesList,
    projectStatusList: state.misReducer.projectStatusList,
    flatFileReport: state.misReducer.flatFileReport,
    issueCategoriesList: state.misReducer.issueCategories,
    issueSubCategoriesList: state.misReducer.issueSubCategoriesList,
    issueStatusList: state.workflowReducer.workflowStateData,
    misIssueList: state.misReducer.misIssueList,
    workflowStateDataForCentral:
      state.workflowReducer.workflowStateDataForCentral,
    sectorsList: state.misReducer.sectorsList,
    // downloadReportData: state.misReducer.downloadReport,
    downloadInProgress: state.misReducer.downloadInProgress,
    recipientGroupsList: state.userManagementReducer.groups,
    statesListData: state.misReducer.statesList,
    selectedState: state.misReducer.selectedState,
    misFlatFileStatus: state.misReducer.misFlatFileStatus,
    misSponoringMinistry: state.misReducer.downloadSponoringMinistry,
    misDownload: state.donwloadExcelReducer.misDownload,
    stateProjectsList: state.misReducer.stateProjectsList,
    documentsStatusLoader: state.misReducer.documentsStatusLoader || false,
    headingDetailsData: state.pmgReducer.headingDetailsData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDownloadMisReportByTypeAction,
      clearMisDownloadByTypeAction,
      getGroupCategoryIdAction: getGroupCategoryIdAction,
      getCategoryAction: getCategoryAction,
      fetchProjectReport: fetchProjectReport,
      fetchProjectDetail: fetchProjectDetail,
      projectMinistry: projectMinistry,
      projectScheme: projectScheme,
      projectMultiLocation: projectMultiLocation,
      projectSingleLocation: projectSingleLocation,
      issueState: issueState,
      issueStatus: issueStatus,
      projectStatus: projectStatus,
      schemeProject: schemeProject,
      fetchAllSchemes: fetchAllSchemes,
      fetchImplementationModes: fetchImplementationModes,
      fetchAllProjectStatus: fetchAllProjectStatus,
      fetchFlatFileReport: fetchFlatFileReport,
      fetchAllIssueCategories: fetchAllIssueCategories,
      fetchWorkflowStateData: fetchWorkflowStateData,
      fetchAllSectors: fetchAllSectors,
      getGroupsAction: getGroupsAction,
      downloadProjectSummary: downloadProjectSummary,
      uploadProjectSummary: uploadProjectSummary,
      getAllStatesDispatch: getAllStatesAction,
      getRecipientMinistryStateAction,
      fetchWorkflowStateDataForCentral,
      getDistrictDepartmentByParentIds,
      fetchStateProjectReport2: fetchStateProjectReport2,
      getMisListAction: getMisListAction
    },
    dispatch
  );
}

function mapActiveReportTitle(activeReport) {
  switch (activeReport) {
    case "FLAT_FILE":
      return "Issues Summary";
    case "ISSUE_STATE":
      return "Ministry/State Agenda";
    case "NODAL_OFFICER":
      return "Nodal Officer Report";
    case "STATE_SUMMARY":
      return "State Summary";
    case "MINISTRY_REPORT":
      return "Ministry Report";
    case "PROJECT_SUMMARY":
      return "Projects Summary";
    case "MEETINGS_SUMMARY":
      return "Meetings Summary";
    case "MINISTRY_REPORT":
      return "Ministry Report";
    case "MINISTRY_COMPLIANCE":
      return "Ministry Compliance";
    default:
      break;
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Mis)
);
